export default function hasScheduledLiveContent() {
    return !!(window.__UpshowState?.upcomingLiveContent?.length);
}
